import BasicRecord from "../../foundation/utils/BasicRecord";

enum ElevatorSectionCountableData {
    Projects = "projects",
    Screens = "screens",
    Components = "components"
}

interface ElevatorSection {
    _id: string;
    type: string;
    name: string;
    path?: string[];
    [ElevatorSectionCountableData.Projects]?: BasicRecord[];
    [ElevatorSectionCountableData.Screens]?: string[];
    [ElevatorSectionCountableData.Components]?: string[];
}

export { ElevatorSectionCountableData, ElevatorSection };
